import { cn } from '@repo/ui/lib/cn';
import * as React from 'react';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

const PageContainer = React.forwardRef<HTMLDivElement, PageContainerProps>(
  ({ children, className }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('container mx-auto max-w-4xl px-4 py-8', className)}
      >
        {children}
      </div>
    );
  },
);
PageContainer.displayName = 'PageContainer';

export { PageContainer };
